import { Box, TableCell, TableRow, Typography, useTheme } from "@mui/material";
import { ExcludedSecurityObj } from "../../../redux-store/types/onBoarding";
import CustomTable from "../../investorOverview/common/customTable";
import { TableHeaderData } from "../../investorOverview/types";

const headerData: TableHeaderData[] = [
    {
        id: 'securityName',
        label: 'Security Name',
        align: 'left',
        isSortable: false,
    },
]

interface DataTableProps {
    tableBodyData: Array<ExcludedSecurityObj & { isExcluded: boolean; }>;
}

function DataTable({ tableBodyData }: DataTableProps): JSX.Element {
    const theme = useTheme()

    return (
        <>
            {tableBodyData.map((obj, index) => (
                <TableRow
                    key={`${obj.security}-${index}`}
                    sx={{
                        '& td': {
                            paddingTop: "15px",
                            paddingBottom: "15px",
                            borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                        },
                        '& td:first-of-type': {
                            paddingLeft: "15px",
                        }
                    }}
                >
                    <TableCell align="left">
                        <Typography
                            variant="body_500"
                            sx={{
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.primary,
                            }}
                        >
                            {obj?.securityName ?? "-"} {obj?.security ? "(" + obj?.security + ")" : ""}
                        </Typography>
                    </TableCell>
                </TableRow>
            ))}
        </>
    )
}

interface SecurityInclusionTableProps {
    tableData: Array<ExcludedSecurityObj & { isExcluded: boolean; }>;
}

export default function SecurityInclusionTable({
    tableData,
}: SecurityInclusionTableProps): JSX.Element {
    return (
        <Box
            sx={{
                maxHeight: tableData.length > 5 ? "300px" : "auto",
                overflowY: tableData.length > 5 ? "auto" : "visible",
            }}
        >
            <CustomTable
                isLoading={false}
                tableBody={
                    <DataTable tableBodyData={tableData} />
                }
                tableData={tableData}
                tableHeaderData={headerData}
                tableHeadRowCustomStyles={{
                    '& th:first-of-type': {
                        paddingLeft: "20px"
                    }
                }}
                tableBodyCustomStyles={{
                    '& tr:last-child td': {
                        border: 0
                    }
                }}
                loadingRowsNum={5}
                tableDataCount={tableData.length}
                isPaginationVisible={false}
            />
        </Box>
    )
}
